var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInca1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 76,
    viewBox: "0 0 78 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.1343 0H10.8657C4.86473 0 0 4.86091 0 10.8571V65.1429C0 71.1391 4.86473 76 10.8657 76H67.1343C73.1353 76 78 71.1391 78 65.1429V10.8571C78 4.86091 73.1353 0 67.1343 0Z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7924 58.5508C44.2585 58.5508 53.5536 49.263 53.5536 37.8059C53.5536 26.3488 44.2585 17.061 32.7924 17.061C21.3264 17.061 12.0312 26.3488 12.0312 37.8059C12.0312 49.263 21.3264 58.5508 32.7924 58.5508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7313 53.5102C33.7332 53.5102 43.4627 43.7016 43.4627 31.602C43.4627 19.5025 33.7332 9.69385 21.7313 9.69385C9.72945 9.69385 0 19.5025 0 31.602C0 43.7016 9.72945 53.5102 21.7313 53.5102Z",
    fill: "#3F51B5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInca1);
export default __webpack_public_path__ + "static/media/Inca 1.0065224afcdb8f736a88448ab7820be4.svg";
export { ForwardRef as ReactComponent };